<mf-page title="Roles de usuario">
  @if (appUserDto) {
  <mf-column label="Usuario">{{ appUserDto.naturalPerson.email }}</mf-column>
  <mf-row-separator />
  <mf-row>
    <mf-column [md]="10"> Rol </mf-column>
    <mf-column
      [align]="'right'"
      [md]="2">
      Activado
    </mf-column>
  </mf-row>
  <mf-form
    [formGroup]="rolesFrom"
    [closeButtonShow]="true"
    (closeButtonClick)="close()"
    (save)="save($event)">
    @for (role of allRoles; track role.id) {
    <mf-row>
      <mf-column [md]="10">
        {{ role.name }}
      </mf-column>
      <mf-column
        [align]="'right'"
        [md]="2">
        <mf-field-check formControlName="{{ role.name }}" />
      </mf-column>
    </mf-row>
    }
  </mf-form>
  }
</mf-page>
